import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { DatatablesUtils } from '../_utils/datatables';
import { Payment } from '../_models';

export class Payments {
  payments: Payment[];
  total: number;
}

@Injectable()
export class PaymentService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/bureaus/%(bureau_id)s/payments`);
  }

  listPayments(urlParams: any, params: any, dtParams: any = {}): Observable<Payments> {
    const url = sprintf(this.baseUrl, urlParams);
    const apiParams = DatatablesUtils.convertToApiParams(dtParams);
    return this.http.post<Payments>(url, {
      ...params,
      ...apiParams,
    });
  }
}
